
import { Vue, Component, Prop } from 'vue-property-decorator';
import { SskEmekliCevap } from '@/plugins/uyap-plugin/uyap/SskEmekli';

@Component({})
export default class KamuEmekliDetay extends Vue {
  @Prop() data!: SskEmekliCevap;

  get emekliBilgi() {
    return this.data.sorguSonucDVO;
  }

  get emekliKayitlari() {
    return this.emekliBilgi?.emekliKaydi4AList || [];
  }

  get hasData() {
    return this.emekliBilgi && (this.emekliKayitlari.length > 0 || this.emekliBilgi.hataKodu === 995);
  }
}
